module.exports = __webpack_public_path__ + "img/davien_logo.e44426f8.png";